module.exports = __webpack_public_path__ + "img/Menuchat.07bd8493.svg";